// Icons.js
import React from "react";

export const Linkedin = (props) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_44_1018)">
      <path
        d="M15.5564 0.885254H1.24031C0.554531 0.885254 0 1.42666 0 2.09604V16.4712C0 17.1406 0.554531 17.6853 1.24031 17.6853H15.5564C16.2422 17.6853 16.8 17.1406 16.8 16.4745V2.09604C16.8 1.42666 16.2422 0.885254 15.5564 0.885254ZM4.98422 15.2013H2.49047V7.18197H4.98422V15.2013ZM3.73734 6.08932C2.93672 6.08932 2.29031 5.44291 2.29031 4.64557C2.29031 3.84822 2.93672 3.20182 3.73734 3.20182C4.53469 3.20182 5.18109 3.84822 5.18109 4.64557C5.18109 5.43963 4.53469 6.08932 3.73734 6.08932ZM14.3161 15.2013H11.8256V11.3032C11.8256 10.3746 11.8092 9.17697 10.5295 9.17697C9.23344 9.17697 9.03656 10.1909 9.03656 11.2376V15.2013H6.54938V7.18197H8.93812V8.27791H8.97094C9.30234 7.64791 10.1161 6.98182 11.3269 6.98182C13.8502 6.98182 14.3161 8.64213 14.3161 10.8012V15.2013Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_44_1018">
        <rect
          width="16.8"
          height="16.8"
          fill="white"
          transform="translate(0 0.885254)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Instagram = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1767 5.80074C12.6204 5.80183 12.1681 5.3514 12.167 4.79509C12.1659 4.23879 12.6163 3.78645 13.1729 3.78537C13.7294 3.78428 14.1818 4.23497 14.1829 4.79128C14.1837 5.34758 13.7332 5.79965 13.1767 5.80074Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.70808 13.598C6.32641 13.6026 4.39162 11.6757 4.387 9.29341C4.38237 6.91171 6.3098 4.97662 8.69149 4.972C11.0737 4.96737 13.0088 6.89538 13.0134 9.27682C13.018 11.6591 11.09 13.5933 8.70808 13.598ZM8.69448 6.4855C7.14861 6.48822 5.89721 7.74426 5.89993 9.29042C5.90292 10.8369 7.15922 12.088 8.70509 12.085C10.2515 12.082 11.5029 10.8262 11.4999 9.27981C11.4969 7.73337 10.2406 6.48251 8.69448 6.4855Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.18349 1.33779C3.71693 1.12877 4.32738 0.985607 5.22116 0.943423C6.11712 0.900425 6.40316 0.890624 8.68386 0.886271C10.9651 0.881918 11.2511 0.890622 12.1471 0.930357C13.0412 0.969004 13.6519 1.10999 14.1864 1.31683C14.7394 1.52994 15.2086 1.8168 15.6762 2.28247C16.1438 2.74869 16.4317 3.21627 16.6475 3.76849C16.8563 4.30247 16.9995 4.91239 17.0419 5.80673C17.0844 6.70241 17.0947 6.98818 17.0991 9.26919C17.1034 11.5499 17.0942 11.8362 17.055 12.7328C17.0161 13.6263 16.8754 14.2373 16.6685 14.7715C16.4549 15.3246 16.1685 15.7938 15.7029 16.2614C15.2372 16.7292 14.7691 17.0169 14.2169 17.233C13.6829 17.4415 13.073 17.5846 12.1792 17.6273C11.2833 17.6698 10.9972 17.6799 8.7157 17.6842C6.43526 17.6886 6.14923 17.6799 5.25328 17.6404C4.35923 17.6012 3.74823 17.4605 3.21397 17.2539C2.66095 17.04 2.19174 16.754 1.72417 16.288C1.25633 15.8221 0.968119 15.3542 0.75257 14.802C0.543549 14.2683 0.400924 13.6581 0.3582 12.7646C0.315474 11.8684 0.305407 11.582 0.301056 9.30131C0.296688 7.0203 0.305674 6.73453 0.34486 5.83856C0.384329 4.94424 0.524495 4.3335 0.731339 3.7987C0.944978 3.24593 1.23129 2.77699 1.69751 2.30914C2.16317 1.84157 2.63128 1.55307 3.18349 1.33779ZM3.75912 15.8428C4.05551 15.9568 4.50021 16.0929 5.31915 16.1285C6.2053 16.1669 6.47065 16.1754 8.71298 16.171C10.9561 16.1669 11.2215 16.1574 12.1074 16.1157C12.9255 16.0768 13.3702 15.9391 13.6658 15.8237C14.0579 15.6705 14.3372 15.4873 14.6306 15.1937C14.9239 14.8989 15.1055 14.6188 15.2574 14.2267C15.3717 13.93 15.5075 13.485 15.5431 12.6661C15.582 11.7804 15.5902 11.5148 15.5858 9.27192C15.5818 7.02955 15.5722 6.76393 15.5301 5.87803C15.4914 5.05963 15.354 4.61491 15.2383 4.31962C15.0851 3.92689 14.9025 3.64819 14.608 3.35452C14.3135 3.06086 14.0334 2.87987 13.6407 2.728C13.3449 2.61342 12.8996 2.47788 12.0812 2.44223C11.1951 2.40331 10.9294 2.39541 8.68658 2.39977C6.44425 2.40413 6.1789 2.4131 5.29302 2.45502C4.47436 2.49394 4.03019 2.63138 3.73407 2.74706C3.34216 2.90028 3.06292 3.08236 2.76927 3.37712C2.47614 3.67186 2.29461 3.95138 2.14275 4.34438C2.029 4.6405 1.89209 5.08576 1.85699 5.90416C1.81833 6.79032 1.81018 7.05596 1.81453 9.29831C1.81862 11.5412 1.82814 11.8069 1.86978 12.6922C1.90815 13.5111 2.04668 13.9553 2.16181 14.2517C2.31503 14.6433 2.49766 14.9226 2.79186 15.2163C3.08661 15.5088 3.36666 15.6909 3.75912 15.8428Z"
      fill="white"
    />
  </svg>
);

export const Facebook = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_44_1014)">
      <path
        d="M9.00009 0.885254C13.6393 0.885254 17.4001 4.64607 17.4001 9.28525C17.4001 13.5799 14.177 17.1214 10.0178 17.6237V11.8522L12.2901 11.8522L12.7615 9.28525H10.0178V8.37741C10.0178 7.69917 10.1508 7.22963 10.456 6.92964C10.7612 6.62964 11.2386 6.4992 11.9273 6.4992C12.1016 6.4992 12.262 6.50094 12.4044 6.50441C12.6114 6.50945 12.7802 6.51816 12.8977 6.53052V4.20359C12.8508 4.19054 12.7953 4.1775 12.7332 4.16466C12.5925 4.13557 12.4176 4.10752 12.2296 4.0829C11.8367 4.03143 11.3866 3.99487 11.0717 3.99487C9.79977 3.99487 8.83854 4.26697 8.16759 4.83059C7.35781 5.51079 6.97085 6.61561 6.97085 8.17917V9.28525H5.23871V11.8522H6.97085V17.4379C3.31212 16.5301 0.600098 13.2247 0.600098 9.28525C0.600098 4.64607 4.36091 0.885254 9.00009 0.885254Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_44_1014">
        <rect
          width="16.8"
          height="16.8"
          fill="white"
          transform="translate(0.600098 0.885254)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Twitter = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7283 2.21777H16.0897L10.9307 8.11422L16.9999 16.138H12.2477L8.52568 11.2716L4.26682 16.138H1.90396L7.42206 9.83104L1.59985 2.21777H6.47263L9.83703 6.66581L13.7283 2.21777ZM12.8995 14.7245H14.208L5.76163 3.55697H4.35748L12.8995 14.7245Z"
      fill="white"
    />
  </svg>
);
export const Youtube = (props) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_44_1017)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1227 4.26925C16.3834 4.53158 16.5705 4.85778 16.6655 5.21519C17.0168 6.53437 17.0168 9.28537 17.0168 9.28537C17.0168 9.28537 17.0168 12.0364 16.6655 13.3555C16.5705 13.713 16.3834 14.0392 16.1227 14.3015C15.862 14.5638 15.537 14.7531 15.1803 14.8504C13.8668 15.2036 8.6168 15.2036 8.6168 15.2036C8.6168 15.2036 3.3668 15.2036 2.05334 14.8504C1.69655 14.7531 1.37156 14.5638 1.1109 14.3015C0.850238 14.0392 0.663051 13.713 0.56807 13.3555C0.216797 12.0364 0.216797 9.28537 0.216797 9.28537C0.216797 9.28537 0.216797 6.53437 0.56807 5.21519C0.663051 4.85778 0.850238 4.53158 1.1109 4.26925C1.37156 4.00691 1.69655 3.81764 2.05334 3.72037C3.3668 3.36719 8.6168 3.36719 8.6168 3.36719C8.6168 3.36719 13.8668 3.36719 15.1803 3.72037C15.537 3.81764 15.862 4.00691 16.1227 4.26925ZM11.2895 9.28539L6.89863 6.78735V11.7834L11.2895 9.28539Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_44_1017">
        <rect
          width="16.8"
          height="16.8"
          fill="white"
          transform="translate(0.199951 0.885254)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const Logo = (props) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.0961 49.6777L20.365 46.0077L25.0928 42.673C25.167 42.673 25.2444 42.673 25.3186 42.673C25.3928 42.673 25.4669 42.6698 25.5411 42.6666C28.8983 42.5827 32.0201 41.554 34.6517 39.835C37.2833 38.1161 39.4247 35.7103 40.8179 32.8755C41.392 31.7113 41.837 30.4761 42.1402 29.1829C42.4433 27.8896 42.6046 26.5448 42.6046 25.1613C42.6046 20.3238 40.647 15.9442 37.4768 12.7741C34.3067 9.60388 29.9271 7.64308 25.0896 7.6463V4.14395V0.641602C31.8621 0.641602 37.9928 3.38608 42.4304 7.82368C46.8745 12.2516 49.619 18.3823 49.619 25.1548C49.619 31.8564 46.9293 37.9323 42.5691 42.3602C38.2089 46.7881 32.1814 49.5649 25.5024 49.6713C25.4347 49.6713 25.367 49.6745 25.2992 49.6745C25.2347 49.6745 25.167 49.6777 25.0961 49.6777Z"
      fill="url(#paint0_linear_1_15750)"
    />
    <path
      d="M40.8572 16.3925V16.3989C40.8604 16.5731 40.8572 16.7472 40.8507 16.9214C40.8443 17.0955 40.8346 17.2665 40.8249 17.4374C40.5572 21.546 38.7125 25.2258 35.8907 27.8799C33.0688 30.5341 29.273 32.1595 25.0966 32.1627L25.0934 32.1595L25.0901 32.1563C20.9138 32.1563 17.1147 30.5309 14.2961 27.8799C11.4774 25.229 9.62949 21.5493 9.36182 17.4374C10.7582 14.6026 11.9999 9.36521 14.6315 7.64951C17.2631 5.93381 21.2879 7.73336 24.6451 7.64951C22.3295 7.76884 20.2526 8.78471 18.753 10.3553C17.2534 11.9259 16.3343 14.0544 16.3343 16.3957C16.3343 18.8177 17.3147 21.0042 18.8981 22.5877C20.4816 24.1712 22.6714 25.1484 25.0901 25.1484L25.0934 25.1516L25.0966 25.1548C27.5153 25.158 29.7051 24.1776 31.2886 22.5909C32.8753 21.0042 33.8557 18.8145 33.8557 16.3925H37.358H40.8572Z"
      fill="url(#paint1_linear_1_15750)"
    />
    <path
      d="M25.0927 0.631836L29.6851 4.43411L25.096 7.63654C25.0218 7.63654 24.9444 7.63654 24.8702 7.63654C24.796 7.63976 24.7219 7.63976 24.6477 7.64299C21.2905 7.72684 18.1687 8.75561 15.5371 10.4745C12.9055 12.1935 10.7641 14.5993 9.37085 17.4341C8.7968 18.5983 8.35175 19.8335 8.0486 21.1267C7.74545 22.4199 7.57775 23.768 7.57775 25.1547C7.57775 29.9922 9.53533 34.3718 12.7055 37.542C15.8757 40.7121 20.2552 42.6729 25.0927 42.6697V46.1721V49.6744C18.3202 49.6744 12.1895 46.9299 7.7519 42.4923C3.3143 38.058 0.569824 31.9272 0.569824 25.1547C0.569824 18.4532 3.25947 12.3773 7.61968 7.94936C11.9799 3.52144 18.0074 0.744711 24.6832 0.638286C24.7509 0.638286 24.8186 0.635061 24.8863 0.635061C24.9541 0.631836 25.0218 0.631836 25.0927 0.631836Z"
      fill="url(#paint2_linear_1_15750)"
    />
    <path
      d="M40.8571 16.3924L37.3548 18.0501L33.8524 16.3924C33.8492 13.9737 32.8688 11.7871 31.2853 10.2004C29.7018 8.61371 27.5121 7.63654 25.0933 7.63654L25.0901 4.13096V0.631836C25.161 0.631836 25.2288 0.631836 25.2965 0.635061C25.3642 0.638286 25.4319 0.638286 25.4997 0.638286C29.7599 0.747936 33.5976 2.54426 36.3711 5.38549C39.1446 8.22671 40.8539 12.1064 40.8571 16.3924Z"
      fill="url(#paint3_linear_1_15750)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_15750"
        x1="34.9849"
        y1="42.5124"
        x2="34.985"
        y2="8.50254"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#247FFF" />
        <stop offset="0.2074" stop-color="#2283FE" stop-opacity="0.7926" />
        <stop offset="0.4343" stop-color="#1C91FC" stop-opacity="0.5657" />
        <stop offset="0.6703" stop-color="#13A6F9" stop-opacity="0.3297" />
        <stop offset="0.9112" stop-color="#06C5F4" stop-opacity="0.0888" />
        <stop offset="1" stop-color="#00D2F2" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_15750"
        x1="27.7476"
        y1="22.314"
        x2="15.5727"
        y2="10.1391"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D48D" />
        <stop offset="1" stop-color="#00D48D" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_15750"
        x1="15.1258"
        y1="7.90044"
        x2="15.1258"
        y2="41.9225"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D2F2" />
        <stop offset="0.2137" stop-color="#02CEF3" />
        <stop offset="0.4365" stop-color="#07C1F5" />
        <stop offset="0.6634" stop-color="#10ACF8" />
        <stop offset="0.8919" stop-color="#1D8FFC" />
        <stop offset="1" stop-color="#247FFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_15750"
        x1="37.0645"
        y1="12.6929"
        x2="28.4371"
        y2="4.65509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D48D" />
        <stop offset="0.2532" stop-color="#00D4A2" />
        <stop offset="0.7744" stop-color="#00D3D9" />
        <stop offset="1" stop-color="#00D2F2" />
      </linearGradient>
    </defs>
  </svg>
);
export const Ico = (props) => (
  <svg
    width="258"
    height="51"
    viewBox="0 0 258 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M83.122 34.5926C81.7159 35.6794 80.2485 36.4824 78.7134 37.0113C77.1816 37.537 75.5013 37.8014 73.6824 37.8014C71.8926 37.8014 70.2156 37.4725 68.6514 36.821C67.0841 36.1664 65.7296 35.2795 64.5783 34.1604C63.4269 33.0446 62.5239 31.7094 61.8725 30.1614C61.2178 28.6134 60.8921 26.9429 60.8921 25.153C60.8921 23.3954 61.2114 21.7506 61.8499 20.2187C62.4885 18.6869 63.3495 17.3614 64.4364 16.2423C65.5232 15.1232 66.8164 14.2396 68.316 13.5817C69.8189 12.927 71.4153 12.6013 73.1084 12.6013C74.7693 12.6013 76.3269 12.9302 77.7782 13.5817C79.2327 14.2364 80.4775 15.1297 81.516 16.2649C82.5512 17.4001 83.3768 18.7481 83.9831 20.3123C84.5894 21.8764 84.8925 23.5534 84.8925 25.3433V26.7332H65.6328C65.9521 28.7456 66.8777 30.4162 68.4128 31.7417C69.9447 33.0671 71.7668 33.7283 73.8759 33.7283C75.0563 33.7283 76.1915 33.538 77.2783 33.1542C78.3651 32.7704 79.2907 32.2448 80.0583 31.574L83.122 34.5926ZM73.0149 16.6229C71.196 16.6229 69.606 17.2292 68.2483 18.445C66.8906 19.6608 66.036 21.2249 65.6844 23.1406H80.1518C79.8003 21.2894 78.9618 19.7382 77.6363 18.4934C76.3108 17.2453 74.7693 16.6229 73.0149 16.6229Z"
      fill="white"
    />
    <path
      d="M95.3855 37.3713L84.8462 12.9838H90.1158L97.7365 31.2373L105.354 12.9838H110.478L99.9392 37.3713H95.3855Z"
      fill="white"
    />
    <path
      d="M132.664 34.5924C131.258 35.6792 129.791 36.4822 128.256 37.0111C126.724 37.5368 125.047 37.8013 123.225 37.8013C121.435 37.8013 119.758 37.4723 118.194 36.8209C116.63 36.1662 115.272 35.2793 114.121 34.1602C112.973 33.0444 112.07 31.7092 111.415 30.1612C110.76 28.6132 110.435 26.9427 110.435 25.1528C110.435 23.3952 110.754 21.7504 111.392 20.2186C112.031 18.6867 112.892 17.3612 113.979 16.2421C115.066 15.1231 116.359 14.2394 117.862 13.5815C119.361 12.9268 120.961 12.6011 122.654 12.6011C124.315 12.6011 125.873 12.9301 127.327 13.5815C128.778 14.2362 130.023 15.1295 131.065 16.2647C132.103 17.3999 132.926 18.748 133.532 20.3121C134.138 21.8762 134.441 23.5532 134.441 25.3431V26.7331H115.182C115.501 28.7455 116.427 30.416 117.962 31.7415C119.494 33.067 121.316 33.7281 123.425 33.7281C124.605 33.7281 125.74 33.5378 126.827 33.154C127.914 32.7703 128.84 32.2446 129.607 31.5738L132.664 34.5924ZM122.554 16.6227C120.735 16.6227 119.145 17.229 117.788 18.4448C116.43 19.6606 115.575 21.2248 115.224 23.1404H129.694C129.343 21.2893 128.504 19.738 127.179 18.4932C125.85 17.2451 124.312 16.6227 122.554 16.6227Z"
      fill="white"
    />
    <path
      d="M138.176 37.3695V12.9821H142.968V16.0974C143.703 14.9171 144.645 14.0141 145.796 13.3916C146.948 12.7692 148.241 12.4564 149.679 12.4564C150.189 12.4564 150.637 12.4886 151.021 12.5531C151.405 12.6176 151.772 12.7112 152.124 12.8402V17.152C151.676 16.994 151.214 16.865 150.734 16.7682C150.253 16.6715 149.776 16.6231 149.296 16.6231C147.889 16.6231 146.638 17.0004 145.535 17.7486C144.432 18.5 143.578 19.6094 142.971 21.0768V37.3663H138.176V37.3695Z"
      fill="white"
    />
    <path
      d="M162.402 39.6707L163.36 37.468L153.633 12.9838H158.903L166.043 31.6211L173.902 12.9838H179.075L167.288 40.2931C166.169 42.8828 164.892 44.7404 163.457 45.8756C162.018 47.0076 160.183 47.5752 157.945 47.5752C157.436 47.5752 156.965 47.5526 156.533 47.5042C156.1 47.4559 155.726 47.3849 155.407 47.2882V43.0731C155.726 43.1376 156.052 43.186 156.387 43.2182C156.723 43.2505 157.113 43.2666 157.561 43.2666C158.648 43.2666 159.596 42.9699 160.412 42.3797C161.225 41.7863 161.889 40.8865 162.402 39.6707Z"
      fill="white"
    />
    <path
      d="M178.996 25.1526C178.996 23.395 179.325 21.7438 179.98 20.1958C180.634 18.6478 181.537 17.3062 182.685 16.171C183.837 15.039 185.185 14.1425 186.733 13.4878C188.281 12.8331 189.935 12.5074 191.693 12.5074C193.451 12.5074 195.102 12.8363 196.65 13.4878C198.198 14.1425 199.539 15.039 200.675 16.171C201.807 17.3062 202.703 18.6478 203.358 20.1958C204.012 21.7438 204.341 23.3982 204.341 25.1526C204.341 26.9425 204.012 28.6098 203.358 30.161C202.703 31.709 201.81 33.0506 200.675 34.1858C199.539 35.321 198.198 36.2144 196.65 36.869C195.102 37.5237 193.447 37.8527 191.693 37.8527C189.935 37.8527 188.284 37.5237 186.733 36.869C185.185 36.2144 183.834 35.321 182.685 34.1858C181.537 33.0506 180.634 31.709 179.98 30.161C179.325 28.6098 178.996 26.9425 178.996 25.1526ZM191.696 33.6344C193.899 33.6344 195.776 32.812 197.324 31.1672C198.872 29.5225 199.646 27.5198 199.646 25.1558C199.646 22.7919 198.872 20.7956 197.324 19.167C195.776 17.5384 193.899 16.7225 191.696 16.7225C189.493 16.7225 187.607 17.5384 186.043 19.167C184.479 20.7956 183.695 22.7919 183.695 25.1558C183.695 27.5198 184.469 29.5225 186.017 31.1672C187.565 32.8088 189.458 33.6344 191.696 33.6344Z"
      fill="white"
    />
    <path
      d="M208.172 37.37V12.9825H212.964V15.4271C213.922 14.4692 215.015 13.7436 216.247 13.247C217.476 12.7503 218.827 12.5052 220.295 12.5052C223.075 12.5052 225.355 13.3921 227.145 15.1658C228.931 16.9396 229.828 19.2293 229.828 22.0415V37.3732H225.035V22.8542C225.035 20.9386 224.484 19.4293 223.384 18.3263C222.281 17.2234 220.82 16.6751 218.998 16.6751C217.721 16.6751 216.563 16.946 215.525 17.4911C214.486 18.0361 213.632 18.8165 212.961 19.8389V37.3732H208.172V37.37Z"
      fill="white"
    />
    <path
      d="M255.659 34.5924C254.253 35.6792 252.782 36.4822 251.251 37.0111C249.719 37.54 248.038 37.8013 246.22 37.8013C244.43 37.8013 242.753 37.4723 241.189 36.8209C239.624 36.1662 238.267 35.2793 237.115 34.1602C235.967 33.0444 235.061 31.7092 234.41 30.1612C233.755 28.6132 233.429 26.9427 233.429 25.1528C233.429 23.3952 233.748 21.7504 234.387 20.2186C235.026 18.6867 235.887 17.3612 236.973 16.2421C238.057 15.1231 239.354 14.2394 240.853 13.5815C242.356 12.9268 243.952 12.6011 245.646 12.6011C247.306 12.6011 248.864 12.9301 250.315 13.5815C251.77 14.2362 253.015 15.1295 254.053 16.2647C255.092 17.3999 255.914 18.748 256.52 20.3121C257.126 21.8762 257.43 23.5532 257.43 25.3431V26.7331H238.17C238.489 28.7455 239.415 30.416 240.95 31.7415C242.485 33.067 244.304 33.7281 246.413 33.7281C247.593 33.7281 248.729 33.5378 249.812 33.154C250.899 32.7703 251.825 32.2446 252.592 31.5738L255.659 34.5924ZM245.549 16.6227C243.73 16.6227 242.14 17.229 240.782 18.4448C239.424 19.6606 238.57 21.2248 238.218 23.1404H252.689C252.337 21.2893 251.499 19.738 250.173 18.4932C248.848 17.2451 247.306 16.6227 245.549 16.6227Z"
      fill="white"
    />
    <path
      d="M25.0963 49.6776L20.3652 46.0075L25.0931 42.6729C25.1673 42.6729 25.2447 42.6729 25.3188 42.6729C25.393 42.6729 25.4672 42.6696 25.5414 42.6664C28.8986 42.5826 32.0204 41.5538 34.652 39.8349C37.2836 38.1159 39.425 35.7101 40.8182 32.8753C41.3922 31.7111 41.8373 30.4759 42.1404 29.1827C42.4436 27.8895 42.6048 26.5446 42.6048 25.1611C42.6048 20.3236 40.6473 15.944 37.4771 12.7739C34.3069 9.60369 29.9274 7.64289 25.0899 7.64612V4.14377V0.641418C31.8624 0.641418 37.9931 3.38589 42.4307 7.8235C46.8747 12.2514 49.6192 18.3821 49.6192 25.1546C49.6192 31.8562 46.9296 37.9321 42.5694 42.36C38.2092 46.788 32.1816 49.5647 25.5027 49.6711C25.4349 49.6711 25.3672 49.6743 25.2995 49.6743C25.235 49.6743 25.1673 49.6776 25.0963 49.6776Z"
      fill="url(#paint0_linear_25_1087)"
    />
    <path
      d="M40.8572 16.3926V16.399C40.8604 16.5732 40.8572 16.7473 40.8507 16.9215C40.8443 17.0956 40.8346 17.2666 40.8249 17.4375C40.5572 21.5461 38.7125 25.2259 35.8907 27.88C33.0688 30.5342 29.273 32.1596 25.0966 32.1628L25.0934 32.1596L25.0901 32.1564C20.9138 32.1564 17.1147 30.531 14.2961 27.88C11.4774 25.2291 9.62949 21.5494 9.36182 17.4375C10.7582 14.6027 11.9999 9.3653 14.6315 7.6496C17.2631 5.9339 21.2879 7.73345 24.6451 7.6496C22.3295 7.76893 20.2526 8.7848 18.753 10.3554C17.2534 11.926 16.3343 14.0545 16.3343 16.3958C16.3343 18.8178 17.3147 21.0043 18.8981 22.5878C20.4816 24.1713 22.6714 25.1485 25.0901 25.1485L25.0934 25.1517L25.0966 25.1549C27.5153 25.1581 29.7051 24.1777 31.2886 22.591C32.8753 21.0043 33.8557 18.8146 33.8557 16.3926H37.358H40.8572Z"
      fill="url(#paint1_linear_25_1087)"
    />
    <path
      d="M25.0927 0.631744L29.6851 4.43402L25.096 7.63645C25.0218 7.63645 24.9444 7.63645 24.8702 7.63645C24.796 7.63967 24.7219 7.63967 24.6477 7.6429C21.2905 7.72675 18.1687 8.75552 15.5371 10.4744C12.9055 12.1934 10.7641 14.5992 9.37085 17.434C8.7968 18.5982 8.35175 19.8334 8.0486 21.1266C7.74545 22.4198 7.57775 23.7679 7.57775 25.1546C7.57775 29.9921 9.53533 34.3717 12.7055 37.5419C15.8757 40.7121 20.2552 42.6728 25.0927 42.6696V46.172V49.6743C18.3202 49.6743 12.1895 46.9298 7.7519 42.4922C3.3143 38.0579 0.569824 31.9271 0.569824 25.1546C0.569824 18.4531 3.25947 12.3772 7.61968 7.94927C11.9799 3.52134 18.0074 0.744619 24.6832 0.638194C24.7509 0.638194 24.8186 0.634969 24.8863 0.634969C24.9541 0.631744 25.0218 0.631744 25.0927 0.631744Z"
      fill="url(#paint2_linear_25_1087)"
    />
    <path
      d="M40.8569 16.3924L37.3545 18.05L33.8522 16.3924C33.8489 13.9736 32.8685 11.7871 31.2851 10.2004C29.7016 8.61368 27.5118 7.63651 25.0931 7.63651L25.0898 4.13093V0.631805C25.1608 0.631805 25.2285 0.631805 25.2962 0.63503C25.364 0.638255 25.4317 0.638255 25.4994 0.638255C29.7596 0.747905 33.5974 2.54423 36.3709 5.38546C39.1444 8.22668 40.8536 12.1064 40.8569 16.3924Z"
      fill="url(#paint3_linear_25_1087)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_25_1087"
        x1="34.9852"
        y1="42.5122"
        x2="34.9852"
        y2="8.50236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#247FFF" />
        <stop offset="0.2074" stop-color="#2283FE" stop-opacity="0.7926" />
        <stop offset="0.4343" stop-color="#1C91FC" stop-opacity="0.5657" />
        <stop offset="0.6703" stop-color="#13A6F9" stop-opacity="0.3297" />
        <stop offset="0.9112" stop-color="#06C5F4" stop-opacity="0.0888" />
        <stop offset="1" stop-color="#00D2F2" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_25_1087"
        x1="27.7476"
        y1="22.3141"
        x2="15.5727"
        y2="10.1392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D48D" />
        <stop offset="1" stop-color="#00D48D" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_25_1087"
        x1="15.1258"
        y1="7.90035"
        x2="15.1258"
        y2="41.9224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D2F2" />
        <stop offset="0.2137" stop-color="#02CEF3" />
        <stop offset="0.4365" stop-color="#07C1F5" />
        <stop offset="0.6634" stop-color="#10ACF8" />
        <stop offset="0.8919" stop-color="#1D8FFC" />
        <stop offset="1" stop-color="#247FFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_25_1087"
        x1="37.0642"
        y1="12.6928"
        x2="28.4368"
        y2="4.65506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00D48D" />
        <stop offset="0.2532" stop-color="#00D4A2" />
        <stop offset="0.7744" stop-color="#00D3D9" />
        <stop offset="1" stop-color="#00D2F2" />
      </linearGradient>
    </defs>
  </svg>
);
